module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1036-091375ab28a7863d26500dca1bbf5203.png";